// import { showAlert, hideAlert } from './alert';
import { apiClient, __uniqBy } from '../../utils';
import { uploadMedias, sendPost, toPost, toSitePost, handleError } from '../';
import {
  UPLOAD_MEDIA_FOREIGN_TYPES,
  POST_CHAIN_CREATED_SUCCESSFULLY,
  POST_CHAIN_MEDIAS_UPLOADED_SUCCESSFULLY,
  POST_CREATED_SUCCESSFULLY,
} from '../../config';
import { Observable } from 'rxjs';

export const createPost = ({
  tl,
  si,
  tx,
  lt,
  ln,
  files,
  titles,
  texts,
  modelFile,
  price,
  filters,
  userSiteFilters,
  inventory,
  inventoryFilters,
  siteService,
  siteId,
  showInUneed,
  showInPersonalSite,
}) => {
  return new Observable(async (subscriber) => {
    try {
      const sharedPayload = {
        ...(tl ? { tl } : {}),
        ...(tx ? { tx } : {}),
        ...(titles ? { titles } : {}),
        ...(texts ? { texts } : {}),
        ...(price ? { price } : {}),
        ...(inventory ? { inventory } : {}),
        ...(inventoryFilters ? { inventoryFilters } : {}),
        ...(lt ? { lt } : {}),
        ...(ln ? { ln } : {}),
      };

      const rsp = await apiClient.post('/postChain/create', {
        data: {
          ...sharedPayload,
          ...(siteService ? { siteService } : {}),
          ...(filters || userSiteFilters
            ? {
                // combining site & uneed filterValues and removing those filters that are shared.
                filters: __uniqBy(
                  [...(filters || []), ...(userSiteFilters || [])],
                  '_id'
                ),
              }
            : {}),
          ...(si ? { si } : {}),
        },
      });

      subscriber.next({
        event: POST_CHAIN_CREATED_SUCCESSFULLY,
        payload: rsp?.result?.postChain,
      });

      const pi = rsp.result?.postChain?._id;

      const medias = await uploadMedias({
        // attach 3d model file if there is any
        medias: modelFile ? [...files, modelFile] : files,
        ft: UPLOAD_MEDIA_FOREIGN_TYPES.POST_CHAIN,
        fi: pi,
      });

      subscriber.next({
        event: POST_CHAIN_MEDIAS_UPLOADED_SUCCESSFULLY,
        payload: medias,
      });

      const postResponse = await (showInUneed &&
        toPost({ si, pi, ...(filters ? { filters } : {}), ...sharedPayload }));

      const sitePostResponse = await (showInPersonalSite &&
        toSitePost({
          pi,
          siteId,
          siteService,
          userSiteFilters,
          ...sharedPayload,
        }));

      subscriber.next({
        event: POST_CREATED_SUCCESSFULLY,
        payload: {
          post: postResponse?.result?.post || null,
          sitePost: sitePostResponse?.result?.postSite || null,
        },
      });
      subscriber.complete();
    } catch (e) {
      handleError(e.data);
      subscriber.error(e.data);
    }
  });
};
